<template>
    <footer class="footer">
        <div class="container">
            <div class="columns footer-navigation">
                <div class="column is-half">
                    <div class="footer-section">
                        <h3 class="footer-section-title">
                            {{ $t('footer.newsletter.label') }}
                        </h3>
                        <div class="field has-addons">
                            <div class="control is-expanded">
                                <input
                                    v-model="e_mail"
                                    @keypress.enter="
                                        showNewsletterModal =
                                            !showNewsletterModal
                                    "
                                    class="input"
                                    type="email"
                                    :placeholder="
                                        $t(
                                            'footer.newsletter.inputLabels.email'
                                        )
                                    "
                                />
                            </div>
                            <div class="control">
                                <a
                                    class="button is-primary-dark"
                                    @click="
                                        showNewsletterModal =
                                            !showNewsletterModal
                                    "
                                    >{{
                                        $t('footer.newsletter.inputLabels.next')
                                    }}
                                    <SvgIcon
                                        icon="icon--directional_arrow-right"
                                        class="is-light ml-5"
                                    />
                                </a>
                            </div>
                        </div>
                        <b-modal
                            v-model="showNewsletterModal"
                            :class="{ 'is-active': showNewsletterModal }"
                            width="640px"
                            scroll="keep"
                            :full-screen="
                                [
                                    viewports.MOBILE.name,
                                    viewports.TABLET.name,
                                ].includes(currentViewport)
                            "
                            :can-cancel="['outside', 'escape']"
                        >
                            <NewsletterForm
                                :mail-from-parent="e_mail"
                            ></NewsletterForm>
                        </b-modal>
                    </div>
                    <div class="footer-section">
                        <h3 class="footer-section-title">
                            {{ $t('footer.socialMedia.label') }}
                        </h3>
                        <div class="footer-section-tiles">
                            <a
                                href="https://www.facebook.com/MurtfeldtAS/"
                                target="_blank"
                                class="footer-section-tile"
                                aria-label="Murtfeldt Additive Solutions Facebook Page"
                            >
                                <img
                                    src="@/assets/img/social-media-icons/facebook.png"
                                    alt="Murtfeldt Additive Solutions Facebook Page"
                                    title="Facebook"
                                />
                            </a>
                            <a
                                href="https://www.linkedin.com/company/murtfeldt-as/"
                                target="_blank"
                                class="footer-section-tile"
                            >
                                <img
                                    src="@/assets/img/social-media-icons/linkedin.png"
                                    alt="Murtfeldt Additive Solutions LinkedIn Page"
                                    title="LinkedIn"
                                />
                            </a>
                            <a 
                                href="https://www.xing.com/pages/murtfeldt-additive-solutions-gmbh"
                                target='_blank'
                                class="footer-section-tile tile-offset"
                            >
                                <img 
                                    src="@/assets/img/social-media-icons/xing.png"
                                    alt="Murtfeldt Additive Solutions Xing Page"
                                    title="Xing"
                                    class="tile-offset"
                                >
                            </a>
                        </div>
                    </div>
                </div>
                <div v-if="footerLeft" class="column is-one-quarter-tablet">
                    <div class="footer-section">
                        <div class="footer-section-title">
                            Murtfeldt Additive Solutions
                        </div>
                        <RouterLink
                            v-for="(footerLink, childIndex) in footerLeft"
                            class="footer-nav-item"
                            :to="footerLink.link"
                            :key="childIndex"
                        >
                            {{ footerLink.title }}
                        </RouterLink>
                        <RouterLink
                            class="footer-nav-item"
                            to="/kontakt#contact-form"
                        >
                            {{ $t('footer.navigation.reportBug') }}
                        </RouterLink>
                    </div>
                </div>
                <div v-if="footerRight" class="column is-one-quarter-tablet">
                    <div class="footer-section">
                        <div class="footer-section-title">
                            {{ $t('footer.legal.label') }}
                        </div>
                        <RouterLink
                            v-for="(footerLink, childIndex) in footerRight"
                            class="footer-nav-item"
                            :to="footerLink.link"
                            :key="childIndex"
                        >
                            {{ footerLink.title }}
                        </RouterLink>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copyright">
            <div class="container">
                © Murtfeldt Additive Solutions GmbH
                {{ new Date(Date.now()).getFullYear() }}
            </div>
        </div>
    </footer>
</template>

<script>
import { mapGetters } from 'vuex';
import SvgIcon from '../svg/SvgIcon';
import NewsletterForm from '../Forms/NewsletterForm';
import ModalView from '../shared/ModalView';
import { viewports } from '../../store/constants/viewports';

export default {
    name: 'Footer',
    components: { SvgIcon, NewsletterForm, ModalView },
    data() {
        return {
            e_mail: '',
            showNewsletterModal: false,
            viewports,
        };
    },
    computed: {
        ...mapGetters(['cmsPage', 'currentViewport']),
        footerLeft() {
            if (this.cmsPage.page) {
                return this.cmsPage.page.navigation.footerleft;
            }
            return null;
        },
        footerRight() {
            if (this.cmsPage.page) {
                return this.cmsPage.page.navigation.footerright;
            }
            return null;
        },
    },
    methods: {
        closeModal() {
            this.showNewsletterModal = false;
        },
    },
};
</script>
